import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import { setAPIStatus } from "../apiState.interface";
import { invokeVouchersForLocationPartner, resultVouchersForLocationPartner } from "./voucher.action";
import { VoucherWithResultDto } from "src/app/shared/models/voucher/voucherWithResultDto";
import { VoucherService } from "src/app/shared/services/voucher.service";
@Injectable()
export class VoucherEffect {
  constructor(private actions$: Actions, private voucherService: VoucherService) {}

  invokeVouchersForLocationPartner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeVouchersForLocationPartner),
      mergeMap((state) => {
        return this.voucherService.filterVouchersForPartnerLocation(state.filter).pipe(
          map((data: VoucherWithResultDto | null) => resultVouchersForLocationPartner({ vouchers: data })),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );
}